import hash from "object-hash";

function getItemStamp(item, loyaltyRules) {
  for (let loyaltyRuleId in loyaltyRules) {
    let loyaltyRule = loyaltyRules[loyaltyRuleId];

    let collectibleArray = loyaltyRule.collectibleItems.map(x => x.id);
    if (collectibleArray.includes(item.id)) {
      // let numOfStamps = item.awardedByRule ? item.count - 1 : item.count;
      return {
        numOfStamps: item.count,
        loyaltyRuleId: loyaltyRule.id
      }
    }
  }
  return {
    numOfStamps: 0
  }
}

// Called both from server and client
function getCartWithRewards(cart, userLoyaltyCards, loyaltyRules) {
  // check for items to stamp
  for (let itemHash in cart.items) {
    let item = cart.items[itemHash];
    // if (item.awardedByRule && item.count == 1) continue;

    item.stamp = getItemStamp(item, loyaltyRules);
    item.numOfFreeItems = 0;
  }

  for (let loyaltyRuleId in loyaltyRules) {
    let loyaltyRule = loyaltyRules[loyaltyRuleId];

    // sum stamps for each rule
    let cartStampSumForRule = 0;
    for (let itemHash in cart.items) {
      let item = cart.items[itemHash];
      let collectibleArray = loyaltyRule.collectibleItems.map(x => x.id);
      if (collectibleArray.includes(item.id)) {
        cartStampSumForRule += item.stamp.numOfStamps;
      }
    }

    if (
      userLoyaltyCards &&
      userLoyaltyCards[loyaltyRule.id] &&
      userLoyaltyCards[loyaltyRule.id].numberOfStamps > 0) {
      cartStampSumForRule += userLoyaltyCards[loyaltyRule.id].numberOfStamps;
    }


    // Finding items to award for free in this cart
    for (let itemHash in cart.items) {
      let item = cart.items[itemHash];

      if (cartStampSumForRule < loyaltyRule.collectibleCount)
        break;
      let rewardArray = loyaltyRule.rewardItems.map(x => x.id);
      let collectibleArray = loyaltyRule.collectibleItems.map(x => x.id);
      if (rewardArray.includes(item.id) && loyaltyRule.active) {
        item.numOfFreeItems = Math.floor(cartStampSumForRule / loyaltyRule.collectibleCount);
        if (collectibleArray.includes(item.id)) {
          const oldStampSumForRule = cartStampSumForRule;
          cartStampSumForRule -= item.numOfFreeItems;
          item.numOfFreeItems = Math.floor(cartStampSumForRule / loyaltyRule.collectibleCount);
          if (item.numOfFreeItems == 0) {
            cartStampSumForRule = oldStampSumForRule;
            break;
          }
        }
        
        item.awardedByRule = loyaltyRule.id;
        if (item.numOfFreeItems > item.count) item.numOfFreeItems = item.count;
        cartStampSumForRule -= loyaltyRule.collectibleCount * item.numOfFreeItems;
      }

    }
  }

  return cart;
}

export function calcItemPrice(item, options, checkboxes) {
  let price = +item.price;

  //calc options
  Object.keys(options).forEach((optionName) => {
    price += +item.options
      .find((section) => section.name == optionName)
      .items.find((option) => option.label == options[optionName]).priceVar;
  });

  //calc checkboxes
  for (let checkboxName in checkboxes) {
    const sectionFromMenu = item.checkboxes.find(
      (section) => section.name == checkboxName
    );

    const clientCheckboxSection = checkboxes[checkboxName];
    for (var clientCheckboxItemLabel in clientCheckboxSection.items) {
      const menuCheckbox = sectionFromMenu.items.find(
        (item) => item.label == clientCheckboxItemLabel
      );
      const clientCheckbox =
        clientCheckboxSection.items[clientCheckboxItemLabel];
      if (clientCheckbox.selected > menuCheckbox.maxSelected) {
        throw `Checkbox selected more than maxSelected for checkbox: ${checkboxName}`;
      }
      price += menuCheckbox.priceVar * clientCheckbox.count;
    }
  }

  return price;
}

// called from client and server
export function calcCartPrice(cart, userLoyaltyCards, loyaltyRules) {
  cart = getCartWithRewards(cart, userLoyaltyCards, loyaltyRules)

  let sum = Object.keys(cart.items).reduce((acc, item) => {
    if (!cart.items[item] || !cart.items[item].count || !cart.items[item].price)
      return acc;
    return acc + cart.items[item].count * cart.items[item].price;
  }, 0);

  for (let itemHash in cart.items) {
    let item = cart.items[itemHash];
    if (item.awardedByRule) {
      sum -= item.price * item.numOfFreeItems;
    }
  }
  return { sum, cart };
}

function getItemFromMenu(itemFromCart, menu) {
  // return item with price
  let section = menu.find((s) => {
    return s.title == itemFromCart.section.title;
  });

  const itemFromMenu = section.items.find((i) => {
    return i.name == itemFromCart.name;
  });

  return itemFromMenu;
}

function getItemOptions(itemFromClient, itemFromMenu) { }

// called only from server
export function calcOrderPrice(order, menu, userLoyaltyCards, loyaltyRules) {

  let cart = { items: {} };
  let discounts = [];
  for (let item of order.items) {
    let menuItem = getItemFromMenu(item, menu);
    const itemPrice = calcItemPrice(menuItem, item.options, item.checkboxes);
    let itemHash = hash(item);
    cart.items[itemHash] = { price: itemPrice, count: item.count, id: menuItem.id };

  }
  return calcCartPrice(cart, userLoyaltyCards, loyaltyRules);
}
